import { FIND_USER } from "../../routes";
import customAxios from "../../customAxios";
import { IFindUserInformation } from "../../../types/common.interface";
import utils from "../../../utils";

interface iQuery {
  value: string | undefined;
  target: "province" | "city" | "_id";
}

async function getAllMunicipality(props: IFindUserInformation) {
  // ?? ---------------------------------------------------------------------------------------------------------------------
  // ?? =====================================================================================================================
  // ??                                               Value Validations
  // ?? =====================================================================================================================
  // ?? ---------------------------------------------------------------------------------------------------------------------
  var thisUrl = FIND_USER + "?";
  if (props.page) thisUrl += `page=${props.page}`;
  if (props.limit) thisUrl += `&limit=${props.limit}`;
  const populateFields =
    "municipalityInformation.province municipalityInformation.city municipalityInformation.name municipalityInformation.financialGroupSchool";
  thisUrl += `&populate=${populateFields}`;

  let body: any = {
    query: {
      userTypes: {
        $in: ["MUNICIPALITY"],
      },
    },
  };

  // ** ---------------------------------------------------------------------------------------------------------------------
  // ** =====================================================================================================================
  // **                                                      Local Functions
  // ** =====================================================================================================================
  // ** ---------------------------------------------------------------------------------------------------------------------

  function query({ value, target }: iQuery) {
    body = {
      query: {
        ...body.query,
        "municipalityInformation.province":
          target === "province" ? value : undefined,
        "municipalityInformation.city": target === "city" ? value : undefined,
      },
    };
  }

  // ?? ---------------------------------------------------------------------------------------------------------------------
  // ?? =====================================================================================================================
  // ??                                            Searching For SuperAgent
  // ?? =====================================================================================================================
  // ?? ---------------------------------------------------------------------------------------------------------------------

  if (props?.search?.value) {
    body = {
      query: {
        ...body.query,
        [String(props.search.base)]: utils.convertNumbers2English(
          props.search.value
        ),
      },
    };
  }

  // ?? ---------------------------------------------------------------------------------------------------------------------
  // ?? =====================================================================================================================
  // ??                                                    Filtering For SuperAgent
  // ?? =====================================================================================================================
  // ?? ---------------------------------------------------------------------------------------------------------------------

  if (props?.filters) {
    const { province, city } = props.filters;
    if (province) query({ target: "province", value: province?._id });
    if (city) query({ target: "city", value: city?._id });
  }

  // !! ---------------------------------------------------------------------------------------------------------------------
  // !! =====================================================================================================================
  // !!                                            Try Catch For SuperAgent
  // !! =====================================================================================================================
  // !! ---------------------------------------------------------------------------------------------------------------------
  try {
    return (await customAxios.post(thisUrl, body)).data;
  } catch (error: any) {
    console.log({ GET_ALL_SUPER_AGENT: error });
  }
}

export default getAllMunicipality;
